import { FC } from "react";
import './leftSidebar.css';
import CustomFilterMenu from "./CustomFilterMenu";
import SectorFilter from "./SectorFilter";

const LeftSidebar: FC = () => {
	return (<>
		<CustomFilterMenu />
		<SectorFilter />
	</>);
};


export default LeftSidebar;